import cn from 'classnames';
import ContentLoader from 'react-content-loader';
import { contentLoaderConfig } from 'shared/constants/common';
import { useIsLoggedIn } from 'shared/hooks/useIsLoggedIn';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';
import { isMobile } from '../../../shared/util/utility';
import { LoaderBannerTypes } from '../Banner.types';

export const LoaderSlider = ({ visible, className }: LoaderBannerTypes) => {
	const isLoggedIn = useIsLoggedIn();
	const { resolvedColorScheme } = useResolvedColorScheme();
	const contentLoaderColor = resolvedColorScheme === 'dark' ? contentLoaderConfig.backgroundColor.dark : contentLoaderConfig.backgroundColor.light;

	return visible && isLoggedIn ? (
		<div className={cn(' overflow-hidden', className)}>
			<div
				className={cn('flex ', {
					'gap-2': isMobile(),
					'gap-3': !isMobile(),
				})}
			>
				{[...Array(10)].map((_, i) => (
					<div key={i} className="w-[180px] h-[110px] fullhd:w-[271px] fullhd:h-[165px]">
						<ContentLoader
							className={'w-[180px] h-[110px] fullhd:w-[271px] fullhd:h-[165px]'}
							animate={false}
							width={180}
							height={110}
							backgroundColor={contentLoaderColor}
							foregroundColor={contentLoaderColor}
						>
							<rect className={'w-[180px] h-[110px] fullhd:w-[271px] fullhd:h-[165px]'} x="0" y="0" rx="4" ry="4" />
						</ContentLoader>
					</div>
				))}
			</div>
		</div>
	) : null;
};
